import { supabase } from "@/lib/supabaseClient";
import type { UserWordSetSetting } from "@/types/models";

/** 사용자의 단어장 세트 설정 조회 */
export async function getWordSetSettings(userId: string): Promise<UserWordSetSetting[]> {
  const { data, error } = await supabase.from("user_word_set_settings").select("*").eq("user_id", userId);

  if (error) {
    throw error;
  }
  return data;
}

/**
 * 활성 단어장 세트를 하나만 설정 (나머지 비활성)
 * - 선택한 세트: is_active = true (upsert)
 * - 나머지 세트: is_active = false (upsert)
 */
export async function setActiveWordSet(userId: string, setId: string, allSetIds: string[]): Promise<void> {
  const rows = allSetIds.map(id => ({
    user_id: userId,
    set_id: id,
    is_active: id === setId,
  }));

  const { error } = await supabase.from("user_word_set_settings").upsert(rows, { onConflict: "user_id,set_id" });

  if (error) {
    throw error;
  }
}
